<template>
<div >
  <div class="detailsTitle" >
       <h4>提货单详情</h4>
       <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
    <div class="addressBox" style="margin-bottom:20px;" v-if="billData.isSplit==1">
      <div style="display:flex;justify-content: space-between;">
        <h4 class="title" style="margin-bottom:10px;">
          <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>货物信息</span>
        </h4>
        <el-button type="primary"  @click="exportFn" size="mini" :disabled="isDisable">导出</el-button>
      </div>
    <div >
      <el-table :data="goodList"    bordersize="mini"  class="table"  style="width: 100%" center  border>
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column label="货物状态"  width="80">
              <template slot-scope="scope">
                <div>
                  <span style="color:#F56C6C;" v-if="scope.row.status==1||scope.row.status==2" >在库</span>
                  <span style="color: #67C23A;" v-else-if="scope.row.status==3" >已出库</span>
                </div>
              </template>
          </el-table-column>
          <el-table-column property="cargoBarcode" width="160" label="捆包号"></el-table-column>
          <el-table-column property="productTypeName" width="100" label="货物类型"></el-table-column>
          <el-table-column property="productName"  width="140"  label="品名"></el-table-column>
          <el-table-column property="model" width="120" label="材质"></el-table-column>
          <el-table-column property="specification" width="140"  label="规格"></el-table-column>
          <el-table-column property="weight" width="100" label="重量(吨)"></el-table-column>
          <el-table-column property="contractNumber" width="120" label="合同号"></el-table-column>
          <el-table-column property="agreementNumber" width="120" label="合约号"></el-table-column>
          <el-table-column property="cargoLocation" width="150" label="货位"></el-table-column>
          <el-table-column property="organizationName"  min-width="200" label="仓库企业"></el-table-column>
          <el-table-column property="enterTime" width="160" :formatter="dateTimeFormat" label="入库时间"></el-table-column>
      </el-table>
      <div class="searchBtnBox" style="display:flex;">
            <p style="font-size: 14px;">合计重量<span class="red">{{billData.allWeight}}</span>吨</p>
            <p style="font-size: 14px;margin-left:20px;">合计件数<span class="red">{{billData.productNum}}</span>件</p>
       </div>
    </div>
    </div>
    <div class="addressBox" style="margin-bottom:20px;" v-if="billData.isSplit==2">
       <h4 class="title" style="margin-bottom:10px;">
      <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i> 未拆货物信息</span>
    </h4>
    <div >
      <el-table :data="goodList"    bordersize="mini"  class="table"  style="width: 100%" center  border>
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column property="cargoBarcode" width="160" label="捆包号"></el-table-column>
          <el-table-column property="productTypeName" width="100" label="货物类型"></el-table-column>
          <el-table-column property="productName"  width="140"  label="品名"></el-table-column>
          <el-table-column property="model" width="120" label="材质"></el-table-column>
          <el-table-column property="specification" width="140"  label="规格"></el-table-column>
          <el-table-column property="weight" width="100" label="重量(吨)"></el-table-column>
          <el-table-column property="contractNumber" width="120" label="合同号"></el-table-column>
          <el-table-column property="agreementNumber" width="120" label="合约号"></el-table-column>
          <el-table-column property="cargoLocation" width="150" label="货位"></el-table-column>
          <el-table-column property="organizationName"  min-width="200" label="仓库企业"></el-table-column>
          <el-table-column property="enterTime" width="160" :formatter="dateTimeFormat" label="入库时间"></el-table-column>
      </el-table>
      <div class="searchBtnBox" style="display:flex;">
            <p style="font-size: 14px;">合计重量<span class="red">{{billData.spillSBillWeight}}</span>吨</p>
            <p style="font-size: 14px;margin-left:20px;">合计件数<span class="red">{{goodList.length}}</span>件</p>
       </div>
    </div>
    </div>
    <div class="addressBox" style="margin-bottom:20px;" v-if="billData.isSplit==2">
       <h4 class="title" style="margin-bottom:10px;">
      <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>已拆货物信息</span>
    </h4>
    <div >
      <el-table :data="billData.childGoods"    bordersize="mini"  class="table"  style="width: 100%" center  border>
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column property="cargoBarcode" width="160" label="捆包号"></el-table-column>
          <el-table-column property="productTypeName" width="100" label="货物类型"></el-table-column>
          <el-table-column property="productName"  width="140"  label="品名"></el-table-column>
          <el-table-column property="model" width="120" label="材质"></el-table-column>
          <el-table-column property="specification" width="140"  label="规格"></el-table-column>
          <el-table-column property="weight" width="100" label="重量(吨)"></el-table-column>
          <el-table-column property="contractNumber" width="120" label="合同号"></el-table-column>
          <el-table-column property="agreementNumber" width="120" label="合约号"></el-table-column>
          <el-table-column property="cargoLocation" width="150" label="货位"></el-table-column>
          <el-table-column property="organizationName"  min-width="200" label="仓库企业"></el-table-column>
          <el-table-column property="enterTime" width="160" :formatter="dateTimeFormat" label="入库时间"></el-table-column>
      </el-table>
      <div class="searchBtnBox" style="display:flex;">
            <p style="font-size: 14px;">合计重量<span class="red">{{billData.childGoodWeight}}</span>吨</p>
            <p style="font-size: 14px;margin-left:20px;">合计件数<span class="red">{{billData.childGoods.length}}</span>件</p>
       </div>
    </div>
    </div>
    <div class="addressBox"  style="margin-bottom:20px;">
    <h4 class="title" style="margin-bottom:10px;">
      <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>提货单记录</span>
    </h4>
    <div>
       <el-form :inline="true" ref="billData" enctype="multipart/form-data" :model="billData"   class="demo-form-inline inpBox" label-width="110px" size="mini">
          <div>
            <el-form-item label="创建时间:" prop="createTime">
              <el-date-picker v-model="billData.createTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
                type="datetime"
                :readonly="true"
                  placeholder=""
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="创建人:"  class="jiage" prop="createUserName">
              <span>{{billData.createUserName}}</span>
            </el-form-item>
          </div>
          <div v-if="billData.publishStatus==2">
            <el-form-item label="发布时间:" prop="publishTime">
              <el-date-picker v-model="billData.publishTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
                type="datetime"
                :readonly="true"
                  placeholder=""
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="发布人:"  class="jiage" prop="publishUserName">
              <span>{{billData.publishUserName}}</span>
            </el-form-item>
          </div>
       </el-form>
    </div>
    </div>
     <div class="addressBox" >
       <h4 class="title" style="margin-bottom:10px;">
      <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>提货人车</span>
    </h4>
    <div >
      <el-table :data="carriageList"    bordersize="mini"  class="table"  style="width: 100%" center border >
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column property="vhcNo"  label="提货车号"></el-table-column>
          <el-table-column property="driverName"  label="提货单位/人"></el-table-column>
          <el-table-column property="driverIdentityNo"   label="纳税人识别号/身份证号"></el-table-column>
      </el-table>
    </div>
    </div>
    <div class="addressBox" v-if="flowAuditLogs.length>0">
      <h4 class="title">
        <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>审批记录</span>
      </h4>
      <div>
          <el-table :data="flowAuditLogs"    bordersize="mini"  class="table"  style="width: 100%" center border >
            <el-table-column type="index" width="55" label="序号"></el-table-column>
            <el-table-column property="checkUserName" width="160" label="审批人"></el-table-column>
            <el-table-column property="checkTime" :formatter="dateTimeFormat" width="200" label="审批时间"></el-table-column>
            <el-table-column property="status"  width="130" label="审批状态" >
              <template scope="scope">
                {{[ "待审批","通过", "驳回" ][scope.row.status]}}
              </template>
            </el-table-column>
            <el-table-column property="checkReason" min-width="260" label="审批意见"></el-table-column>

        </el-table>
      </div>
    </div>

    <div class="addressBox" v-if="records.length>0">
      <h4 class="title">
        <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>撤回记录</span>
      </h4>
      <div>
        <el-table :data="records"    bordersize="mini"  class="table"  style="width: 100%" center border >
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column property="createTime" :formatter="dateTimeFormat" width="200" label="撤回时间"></el-table-column>
          <el-table-column property="reason" min-width="260" label="撤回原因"></el-table-column>
        </el-table>
      </div>
    </div>
</div>
</template>

<script>
import { goodsDetail } from '@/api/soc-stock'
import { dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDown.js'
export default {
  data () {
    let id = this.$route.query.id
    return {
      dateTimeFormat: dateTimeFormat,
      dialogVehM: false,
      mapData: '',
      id: id,
      carriageList: [],
      goodList: [],
      flowAuditLogs: [],
      billData: {
        childGoods: []
      },
      isDisable: false,
      records: [] // 撤回记录
    }
  },
  created () {
    goodsDetail({ id: this.id }).then(res => {
      this.records = res.records
      this.carriageList = res.carriageList
      this.goodList = res.goodsList
      this.billData = res.sBill
      this.billData.childGoods = res.childGoods
      this.billData.childGoodWeight = res.childGoodWeight
      this.billData.spillSBillWeight = res.spillSBillWeight
      this.flowAuditLogs = res.flowAuditLogs
    })
  },
  mounted () {
  },
  methods: {
    // 导出
    exportFn () {
      exportExcel(
        this.global.stockName + '/sBillWayProduct/billWayProductListExport',
        { id: this.id },
        '货物信息'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox  /deep/.el-input__inner{
  border:none;
  padding: 0;
  color:#333;
   font-size: 14px;
}
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-form-item--mini.el-form-item{
    margin-bottom: 0px;
}
/deep/.el-input.is-disabled .el-input__inner{
  background: #fff;
}
 /deep/.el-input__suffix, /deep/.el-input__icon{
   display: none;
 }
 .danwei{
   /deep/ .el-input__inner{
         width: 300px;
    overflow: auto;
   }
 }
.box1{
  display: flex;
  padding-left: 20px;
  .item{
    max-width: 48%;
    margin-left: 10px;
    font-size: 14px;
  }
  .box1T{
    margin-bottom: 10px;
    font-weight: bold;
  }
  .box1B{
    display: flex;
    flex-wrap: wrap;
    span{
      margin-right: 20px;
      line-height: 26px;
    }
  }
}
</style>
